/** the character used to separate npi and locationId */
export const KEY_SEPARATOR = ':';

export interface ProviderCostKeyComponents {
  npi: string | number;
  locationId: string;
}

export function createProviderCostKey({ npi, locationId }: ProviderCostKeyComponents): string {
  if (!npi) throw new Error('Invalid npi');
  if (!locationId) throw new Error('Invalid locationId');

  return `${npi}${KEY_SEPARATOR}${locationId}`;
}

export function destructureProviderCostKey(key: string): ProviderCostKeyComponents {
  const i = key.indexOf(KEY_SEPARATOR);
  if (i < 0) throw new Error(`Invalid provider cost key - does not contain ${KEY_SEPARATOR}`);
  const npi = key.slice(0, i);
  const locationId = key.slice(i + 1);

  return { npi, locationId };
}
